import useContent from './useContent';

const withContent = (propName, ...params) => (Component) => (props) => (
    <Component {...{ [propName]: useContent(...params) }} {...props} />
);

export default withContent;
